import AdminDeletedEventsList from "./deletedEvents";

export default AdminDeletedEventsList;
